// Маска для ввода даты: оставляем только цифры и расставляем точки по шаблону ДД.ММ.ГГГГ.
// "15" -> "15", "1506" -> "15.06", "15062015" -> "15.06.2015".
// Ручные точки из ввода удаляются и проставляются автоматически.
export const maskDateInput = (value = '') => {
	const digits = String(value).replace(/\D/g, '').slice(0, 8)

	const day = digits.slice(0, 2)
	const month = digits.slice(2, 4)
	const year = digits.slice(4, 8)

	if (digits.length > 4) {
		return `${day}.${month}.${year}`
	}
	if (digits.length > 2) {
		return `${day}.${month}`
	}
	return day
}
